import { createStyles } from '@mantine/core';

export const useNonAuthLayoutContainerStyles = createStyles((theme) => ({
  container: {
    [theme.fn.smallerThan('md')]: {
      padding: 0,
    },
  },
  containerRoot: {
    margin: 'unset',
    paddingLeft: 'unset',
    width: '100%',
    maxWidth: 'unset',
  },
}));
